import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';

import '../css/sendRequestButton.css';

import sendIcon from '../images/send2.png';
import inactiveSendIcon from '../images/send-inactive.png';

const SendRequestButton = ({ objectId, supplierId, picked, userToken, isFetchPending, setIsFetchPending, isPickedDone, setIsPickedDone }) => {

  //------ GESTIONE MESSAGGIO BUTTON -----//

  const [isMouseEnter, setIsMouseEnter] = useState(false);

  const handleMouseEnter = () => {
    setIsMouseEnter(true);
  }

  const handleMouseLeave = () => {
    setIsMouseEnter(false);
  }

  //-----//

  //----- MODALE DI CONFERMA INVIO RICHIESTA ---//

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const openConfirmModal = () => {
    setIsConfirmModalOpen(true);
  }

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
  }

  //-----//

  //----- CHIAMATA FETCH DI ATTIVAZIONE PICKED OGGETTO -----//

  const decodedToken = jwtDecode(userToken);
  const navigate = useNavigate();

  const [exchangeData, setExchangeData] = useState(null);

  // CHIAMATA PER PICKARE L'OGGETTO
  
  const sendRequest = async () => {

    try {
      setIsFetchPending(true);
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/roba/pick/${objectId}/${decodedToken.id}`, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json'
        }
      })

        if(response.ok) {
          const pickedObject = await response.json();
          console.log(pickedObject);
        } else {
          console.log('Error: ', response);
        }

    } catch (error) {
      console.log('Error Type: ', error);
    }

    setExchangeData({
      supplier: supplierId,
      taker: decodedToken.id,
      robaObject: objectId,
      status: 'picked'
    })

  }

    // CHIAMATA PER CREARE L'EXCHANGE

    const insertExchange = async () => {

      try {

        const res = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/exchanges/new`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(exchangeData)
        })

        if (res.ok) {
          const exchange = await res.json();
          console.log('exchange: ', exchange);
        } else {
          console.log('Error: ', res);
        }

      } catch (error) {
        console.log('Error Type: ', error);
      }

      setIsFetchPending(false);
      setIsPickedDone(true);

    }

    useEffect(() => {
      if (exchangeData) {
        insertExchange();
      }
    }, [exchangeData])

  //-----//

  return (

    <div>
    {
      !picked ? (

        !isConfirmModalOpen ? (

          <div className="send-request-button"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={openConfirmModal}
          >
          <img src={sendIcon} />
          {isMouseEnter && <div className="send-request-message">Chiedi di poter avere questo oggetto!</div>}
          </div>

        ) : (

          <div className="confirm-request-modal">
            <h2>Confermi di voler inviare la richiesta per avere questo oggetto?</h2>
            <p>Aiuterai il proprietario a liberarsi di questo oggetto senza renderlo un rifiuto e ti impegnerai ad andarlo a prendere a casa sua risparmiandogli scocciature. In cambio avrai questo oggetto gratuitamente.</p>
            <h4>Questo sarà uno scambio equo. nessuno guadagna di più rispetto all'altro, non ci sono fini di lucro o speculativi.</h4>
            <p>Il proprietario dell'oggetto sarà libero di non accettare la richiesta. Questo perché, per esempio, potrebbe aver cambiato idea ed essersi dimenticato di eliminare il prodotto dall'app.</p>
            <h4>Nulla deve essere forzato, ROBA è creata per aiutarsi e contribuire insieme a ridurre gli sprechi.</h4>

            <div className="confirm-request-modal-button">
              <button onClick={sendRequest}>Confermo</button>
              <button onClick={closeConfirmModal}>Torna indietro</button>
            </div>
          </div>
        )

      ) : (

        <div className="send-request-button-inactive">
          <img src={inactiveSendIcon} />
        </div>

      )
    }
    </div>
  )
}

export default SendRequestButton;
